(function($, undefined) {
	'use strict';
	var isLoggedIn = false;
	var isMobile = false;
	var win = $(window);
	var winWidth;
	var winHeight;
	var scrollTop;
	var header;
	var navItems;
	var toggleMenuBtn;
	var utils;
	var updateTop = true;

	var toggleScroll = function() {
		var diff;

		if ($('body').hasClass('no-scroll')) {
			$('body').removeClass('no-scroll');
			diff = 0;
		} else {
			var w1 = win.width();
			$('body').addClass('no-scroll');
			var w2 = win.width();
			diff = w2 - w1;
		}

		changeScrollDiff(diff);
	};

	var changeScrollDiff = function(diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};

	var onClickMenuToggle = function() {
		var id = $(this).attr('data-id');
		if ($('body').hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			$('body').removeClass('menu-open menu-open_main-menu menu-open_account-menu');

			header.on(transitionEnd, function(e) {
				$('body').removeClass('no-scroll');
				changeScrollDiff(0);
				$(this).off(e);
			});
		} else {
			var target = 0;

			if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
				target = $('.site-header').offset().top;
			}

			if (win.scrollTop() <= $('.site-header').offset().top) {
				$('html').animate({ scrollTop: target }, 300);
				$('body').animate({ scrollTop: target }, 300, function() {
					openMenu(id);
				});
			} else {
				openMenu(id);
			}
		}
	};

	var openMenu = function(id) {
		$('body').addClass('menu-open menu-open_'+id);
		toggleScroll();
	};

	var closeMenu = function() {
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open menu-open_main-menu menu-open_account-menu');
			toggleScroll();
		}
	};

	var updateNavSelected = function(page) {
		navItems.removeClass('selected');
		var handleObj = $('.main-content ' + page);
		var handle = handleObj.attr('data-page-nav');

		navItems.each(function() {
			var t = $(this);

			if (t.data('pageNav') === handle) {
				t.addClass('selected');
			}
		});
	};

	/* var pageEnter = function (page) {
		updateNavSelected(page);
	}; */

	var toggleSectionSubnav = function() {
		var section = $(this).closest('.nav-section-item');
        var ctn = section.find('.nav-section-item__links-ctn');
        var boundingRight = ctn[0].getBoundingClientRect().right + 15;

		$('.site-header').find('.nav-section-item_open').not('[data-id*="'+section.attr('data-id')+'"]').removeClass('nav-section-item_open');
		section.toggleClass('nav-section-item_open');
        if (section.hasClass('nav-section-item_open')) {
            if (boundingRight > winWidth + 1) {
                ctn.css('left', Math.floor(winWidth - boundingRight) + 'px');
                ctn.children('.nav-section-item__links-ctn-triangle').css('left', Math.floor(boundingRight - winWidth + 20) + 'px');
            } else {
                // Once it has been adjusted from the condition above, the ctn size will always be within the window frame. So we do nothing
            }
        }
	};

	var updateMainContentMargin = function() {
		if (!utils.isSM()) {
			$('.main-content').css('margin-top', $('.site-header').outerHeight());
		}
	};

	var scrollStick = function() {
		const stickyOffset = $('.site-header__bottom').offset().top;
		const scroll = $(window).scrollTop();

		if (scroll >= scrollTop && scroll !== 0) {
			$('body').addClass('scrolled-down');
			if (updateTop) {
				if ($('.site-header__bottom_microsite').length > 0) {
					$('.site-header').css('top', -$('.site-header__top').outerHeight() - $('.site-header__bottom:not(.site-header__bottom_microsite)').outerHeight());
				} else {
					$('.site-header').css('top', -$('.site-header__top').outerHeight());
				}
			}
		} else {
			$('body').removeClass('scrolled-down');
			if (updateTop) {
				$('.site-header').css('top', 0);
			}
		}

		scrollTop = scroll;
	};

	var handleSearch = function() {
		if (!utils.isSM()) {
			if ($('body').hasClass('search-open') && $('.site-header__desktop-search .form-input').val().length > 0) {
				$('.site-header__desktop-search form').submit();
			} else {
				$('body').toggleClass('search-open');
				setTimeout(function() {
					$('.site-header__desktop-search .form-input').focus();
				}, 300);
			}
		} else {
			$('.site-header__menu-btn').trigger('click');
			setTimeout(function() {
				$('.site-header__mobile-search .form-input').focus();
			}, 300);
		}
	};

	var scrollToSearch = function() {
		var target = $('.search-page__search-bars').offset().top;
		var additionalOffset = $(window).scrollTop() > target ? 160 : 100;
		
		$('html, body').animate({ scrollTop: (target - additionalOffset) }, 300);
	};

	var onSEOImageFilePickerChange = function(e, args) {
		var $img = $(e.currentTarget);
		var $ctn = $img.closest('.seo-item');
		var SEOCustomImageWidthLabel = $ctn.attr("data-custom-seo-image-width-label");
		var SEOCustomImageHeightLabel = $ctn.attr("data-custom-seo-image-height-label");

		if (args.value.length > 0) {
			$img.one("load", () => {
				var width = this.naturalWidth;
				var height = this.naturalHeight;

				saveSEOImageSizeLabels(SEOCustomImageWidthLabel, SEOCustomImageHeightLabel, width, height);
			});
		}
		else {
			saveSEOImageSizeLabels(SEOCustomImageWidthLabel, SEOCustomImageHeightLabel, "", "");
		}
	};

	var saveSEOImageSizeLabels = function(widthLabel, heightLabel, width, height) {
		updateLabel(widthLabel, width, $("html").attr("lang"), () => {
			updateLabel(heightLabel, height, $("html").attr("lang"), () => {
				// nothing
			}, true);
		}, true);
	};

	var checkBrowserVer = function() {
		if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
			if ($('.ie-warning').length > 0) {
				$('.ie-warning').removeClass('ie-warning_hide');
			}
		}
	};

	var editIeWarning = function() {
		if ($('.ie-warning').length > 0) {
			$('.ie-warning').removeClass('ie-warning_hide');
		}
	};

	var closeIeWarning = function() {
		if ($('.ie-warning').length > 0) {
			$('.ie-warning').addClass('ie-warning_hide');
		}
	};

	var ieWarningSeen = function() {
		utils.saveMG2SessionVariable("ieWarningSeen", true, function() {
			closeIeWarning();
		});
	};
    
	var closeTempPopup = function() {
		utils.saveMG2SessionVariable("closeTempPopup", true, function() {});
	};
    
    var switchNavVersion = function(e) {
        const it = $(e.currentTarget);
        let v = '';
        
        if (it.hasClass('active')) {
            it.removeClass('active');
        } else {
            it.addClass('active');
            v = '2';
        }
        
        utils.saveMG2SessionVariable('mainNavVersion', v, function() {
            location.reload();
        });
    };
    
	var init = function() {
		utils = Fw.component.models().utils;
		winWidth = win.width();
		winHeight = win.height();
		$('body').removeClass('no-scroll');

		checkBrowserVer();

		header = $('.site-header');
		navItems = $('.nav-item-link', header);

		toggleMenuBtn = $('.js-header-menu-btn');

		if ($('body').hasClass('is-logged-in')) {
			isLoggedIn = true;
		}

		toggleMenuBtn.on('click', onClickMenuToggle);
		navItems.on('click', closeMenu);
		$('.header-overlay').click(closeMenu);
		updateTop = !utils.isSM();
		
		updateMainContentMargin();
		scrollStick();
		$(window).scroll(function(){
			scrollStick();
		});

		win.resize(function() {
			if (winWidth !== win.width()) {
				closeMenu();
				winWidth = win.width();
			}
			updateTop = !utils.isSM();
			if (utils.isSM()) {
				$('.site-header').removeAttr('style');
				$('.main-content').removeAttr('style');
			}
			updateMainContentMargin();
			if (win.width() != winWidth) {
				winHeight = win.height();
				winWidth = win.width();
			}
		});

		$('.nav-section-item .js-section-subnav').click(toggleSectionSubnav);

		$(document).on('click', (e)  => {
			if (!$(e.target).is('.nav-section-item') && $(e.target).closest('.nav-section-item').length === 0) {
				$('.site-header').find('.nav-section-item_open').removeClass('nav-section-item_open');
			}
			if (!$(e.target).is('.site-header') && $(e.target).closest('.site-header').length === 0) {
				$('body').removeClass('search-open');
			}
		});

		$('.js-header-search-btn').click(handleSearch);
		$('.js-scroll-to-search-bar').click(scrollToSearch);
		$('.edit-ie-warning-btn').click(editIeWarning);
		$('.ie-warning__admin-close-btn').click(closeIeWarning);
		$('.ie-warning__close-btn').click(ieWarningSeen);

		$('.seo-item__preview-image').on("file-picker-change", onSEOImageFilePickerChange);
		$('.share-popup-temp__close-btn').on("click", closeTempPopup);
        
        $('.site-header__main-nav-switch').on('click', switchNavVersion);
        $('.mnv2 .nav-section-item__links-list-wrap').each((i, el) => {
            new MiniBar(el, {
                barType: 'default',
                minBarSize: 10,
                hideBars: false,
                alwaysShowBars: false,
                horizontalMouseScroll: true,
                wheelScrollAmount: 3, // not working, it always scrolls too much
                scrollX: true,
                scrollY: true,
            });
        });
	};

	$(init);

	Fw.component.export('header', {
		toggleScroll,
		changeScrollDiff
	});
})(jQuery);
